// POLICY (client, Aug 20 2026): a past-start OPEN job STAYS OPEN — on screen and in the database.
// Interpreters keep seeing it on their dashboard; they just cannot self-assign it any more (the
// backend refuses the claim and the coordinator assigns manually). This helper therefore passes
// the stored status straight through.
//
// It used to derive 'cnc' for open+past-start jobs (with a 30-minute cron persisting the flip);
// the client reversed that after unintended consequences. The function is kept — every status
// cell and colour helper on both portals already routes through it, so any future display rule
// has one home. CNC as a status still exists: the manual Could Not Cover button sets it.
export const effectiveStatus = (appointment) => {
  if (!appointment) return "";
  return appointment.status;
};
